<template lang="pug">
v-text-field.x-widget(
  :class="{ 'x-widget-readonly': isReadOnly }"
  v-bind="$attrs"
  :value="value"
  :dense="!isLarge"
  :label="myTitle"
  :prepend-inner-icon="myIcon"
  :hide-details="hasNoHints"
  :readonly="isReadOnly"
  disabled
  filled

  persistent-hint
  :hint="`{widget:${componentType}}`"
)
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

export default {

  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Valor editado no componente.
     * @type {Any}
     */
    value: {
      validator: v => true
    },

    // Propriedades de {Keep.Paper.Design.Field} que podem ser sobrescritas...
    name: String,
    title: String,
    description: String,
    hint: String,
    placeholder: String,
    secure: Boolean,
    large: Boolean,
    noHints: Boolean,
  },

  data: () => ({
    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
    },

    revealed: false
  }),

  computed: {
    myName: vm => vm.getIt('name'),
    myTitle: vm => vm.getIt('title') || vm.myName,
    myDescription: vm => vm.getIt('description'),
    myHint: vm => vm.getIt('hint'),
    myPlaceholder: vm => vm.getIt('placeholder'),
    isSecure: vm => vm.hasIt('secure'),
    isLarge: vm => vm.hasIt('large'),
    hasNoHints: vm => vm.hasIt('noHints'),
    isReadOnly: vm => vm.hasIt('readOnly') || vm.hasIt('readonly'),

    myType () { return this.isSecure && !this.revealed ? 'password' : 'text' },
    myIcon () {
      if (!this.isSecure) return null
      return this.revealed ? this.icons.mdiEyeOffOutline : this.icons.mdiEyeOutline
    },
    myAutoComplete () {
      if (this.myName?.toLowerCase() === 'username') return 'username'
      if (this.myName?.toLowerCase() === 'password') return 'current-password'
      return null
    },

    componentType () {
      const type = this.dataType || this.field?.dataType || 'String'
      const allowRange = this.allowRange || this.field?.allowRange

      let name = `Widget${type}`
      if (allowRange) {
        name = `${name}Range`
      }

      return name
    },
  },

  methods: {
    getIt (property) {
      return this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
    },
    hasIt (property) {
      if (this.$props[property] === '') return true
      if (this.$attrs[property] === '') return true
      const value = this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
      return !!value
    },
  },
}
</script>